export const storeAllPayments = (state, action) => {
  state.payments = action.payload.listPaymentMethods.data;
};
